import { render } from "./AlertWarning.vue?vue&type=template&id=db71b5f4&scoped=true&ts=true"
import script from "./AlertWarning.vue?vue&type=script&lang=ts"
export * from "./AlertWarning.vue?vue&type=script&lang=ts"

import "./AlertWarning.vue?vue&type=style&index=0&id=db71b5f4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db71b5f4"]])

export default __exports__